<div class="main-wrapper-section">
    <div class="common-header">
        <h3>Members</h3>
    </div>
    <div class="card-section">
        <div class="card-panel">
            <div class="field-form-panel">
                <div class="flex-form contracts-flex-form top-filter-panel">
                    <div class="form-group">
                        <label>Site</label>
                        <select [(ngModel)]="selectedCMSiteID" (change)="onChangeCMSite()" class="form-control" name="sites">
                            <option value="0">--ALL--</option>
                            <option *ngFor="let opt of cmSites" [value]="opt.siteID">
                                {{ opt.siteName }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>Manager</label>
                        <select [(ngModel)]="selectedUserID" (change)="onChangeUserDD()" class="form-control" name="manager">
                            <option *ngFor="let opt of clpUsersDD" [value]="opt.value">
                                {{ opt.text }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>Member Status</label>
                        <select [(ngModel)]="selectedStatusID" (change)="onChangeMemberStatusDD()" class="form-control" name="status">
                            <option value="0">--ALL--</option>
                            <option *ngFor="let opt of ref_MemCSStatus" [value]="opt.statusID">
                                {{ opt.status }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label *ngIf="selectedCtDtFilter == 1 || selectedCtDtFilter == 2">Time Frame</label>
                        <div *ngIf="selectedCtDtFilter == 1 || selectedCtDtFilter == 2">
                            <select [(ngModel)]="selectedCtDtFilter" (change)="createDtFilterChange($event)" class="form-control" name="status">
                                <option *ngFor="let opt of createDateFilters" [value]="opt.value">
                                    {{ opt.name }}
                                </option>
                            </select>
                        </div>
                        <div class="custom-date" *ngIf="selectedCtDtFilter == 3 || selectedCtDtFilter == 4 || selectedCtDtFilter == 5 || selectedCtDtFilter == 6">
                            <label>Custom Range</label>
                            <div class="display-row">
                                <mat-form-field appearance="outline">
                                    <mat-date-range-input [rangePicker]="dateRangePicker" [formGroup]="currentRange" readonly>
                                        <input matStartDate placeholder="Start date" formControlName="start" #dateRangeStart readonly>
                                        <input matEndDate placeholder="End date" formControlName="end" #dateRangeEnd (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)" readonly>
                                    </mat-date-range-input>
                                    <mat-datepicker-toggle class="custom-daterange-toggle" matPrefix [for]="dateRangePicker"></mat-datepicker-toggle>
                                    <mat-date-range-picker #dateRangePicker></mat-date-range-picker>
                                    <span *ngIf="currentRange.controls.start.hasError('matStartDateInvalid')"><mat-error>Invalid start date</mat-error></span>
                                    <span *ngIf="currentRange.controls.end.hasError('matEndDateInvalid')"><mat-error>Invalid end date</mat-error></span>
                                </mat-form-field>
                                <i class="fa fa-undo" (click)="revertCustomFinalizeddtFilter()" style="font-size:20px; margin-left:10px;"></i>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Search</label>
                        <div class="button-group">
                            <input matInput class="form-control" (keyup)="applyFilter($event.target.value)" placeholder="Search">
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-panel">
                <div class="">
                    <div class="text-right">
                        <!--<div class="button-group" style="border:none;">
                        </div>-->
                    </div>
                </div>
                <div class="table-body">
                    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort>
                        <ng-container *ngFor="let column of columns" [matColumnDef]="column.field">
                            <ng-container>
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ column.title }} </th>
                                <td mat-cell *matCellDef="let dataItem; let rowIndex = index">
                                    <div class="memcon-name" *ngIf="column.field == 'name'">
                                        <a href="javascript:void();" (click)="gotoLink($event, 'memContact', dataItem);">{{dataItem['firstName']}} {{dataItem['lastName']}}</a>
                                    </div>
                                    <div class="memcon-email" *ngIf="column.field == 'email'"><a href="javascript:void();" (click)="gotoLink($event, 'email', dataItem);">{{ dataItem[column.field] }}</a></div>
                                    <div class="memcon-mobile" *ngIf="column.field == 'mobile'"><a href="javascript:void();" (click)="gotoLink($event, 'mobile', dataItem);">{{ dataItem[column.field] | phoneFormat}}</a></div>
                                    <div class="memcon-mobile text-center" *ngIf="column.field == 'cmContractID'">
                                        <a (click)="gotoLink($event, 'cmContract', dataItem);">
                                            <img src="../../../../assets/icon_contact.svg" />
                                        </a>
                                    </div>
                                    <div class="memcon-mobile" *ngIf="column.field == 'memberStatus'">{{ dataItem[column.field]}} </div>
                                    <div class="memcon-mobile" *ngIf="column.field == 'membershipID'"><a href="javascript:void();" (click)="gotoLink($event, 'memMemberShip', dataItem);">{{ dataItem.membershipAccountName}}</a> </div>
                                    <div class="memcon-mobile" *ngIf="column.field == 'subscriptionID'">
                                        <a (click)="gotoLink($event, 'memSubscription', dataItem);" href="javascript:void();">
                                            {{ dataItem[column.field]}}
                                        </a>
                                    </div>
                                    <div class="memcon-mobile" *ngIf="column.field == 'onboardedByCLPUser'">{{ dataItem[column.field]}} </div>
                                    <div class="memcon-mobile" *ngIf="column.field == 'dateOfLastReservation'">{{ dataItem[column.field] | date:dateFormat}} </div>
                                </td>
                            </ng-container>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="memContactListDisplayColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: memContactListDisplayColumns;"
                            [class.selected]="selectedRow === row"></tr>
                    </table>
                    <mat-paginator *ngIf="contactList?.length > 0" [pageSize]="50"
                                   [length]="contactList?.length" [pageSizeOptions]="[10, 50, 100,200]"></mat-paginator>

                </div>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="sendEmail" tabindex="-1" role="dialog" aria-labelledby="sendEmailLabel" aria-hidden="true" data-focus="false">
    <div class="custom-modal-panel" role="document">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content user-body-section border-radius-contact">
                <div class="modal-body p-0">
                    <app-contact-email *ngIf="sendMailInfo?.isShow" [loggedUser]="user" (closeEmailModal)="hideSendMail()" [contactId]="sendMailInfo?.contactId"></app-contact-email>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="sendTextModal" tabindex="-1" role="dialog" aria-labelledby="exampleTextModalLabel" aria-hidden="true" data-focus="false">
    <div class="custom-modal-panel" role="document">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content user-body-section border-radius-contact">
                <div class="modal-body">
                    <app-contact-sms *ngIf="user && selectedContactId > 0" (updatedTextMsg)="hideTextMsgModal($event)" [loggedUser]="user" [contactId]="selectedContactId"></app-contact-sms>
                </div>
            </div>
        </div>
    </div>
</div>
